const LOCALES = Object.freeze(require('../config/locale'));
const OMIT_LOCALES = Object.freeze(require('../config/locale/omitInHeader'));

export const LOCALES_BLOG = [
  'en',
  'cn',
  'kr',
  'ru',
  'vn',
  'it',
  'es',
  'id',
  'tr',
  'de',
  'fr',
  'pt',
  'nl',
  'pl',
  'i18n',
];

const localesKeys = Object.keys(LOCALES).filter(l => !Object.keys(OMIT_LOCALES).includes(l));
const locales = {};
localesKeys.forEach(k => {
  locales[k] = LOCALES[k];
});

const LOCALES_HTML = Object.freeze({
  // just different ones
  en: 'en',
  cn: 'zh-Hans',
  tw: 'zh-Hant',
  kr: 'ko',
  vn: 'vi',
});

const LOCALES_TRADINGVIEW = Object.freeze({
  // just different ones
  en: 'en',
  cn: 'zh',
  tw: 'zh_TW',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  nl: 'nl_NL',
});

const LOCALES_CALENDAR = Object.freeze({
  en: 'en',
  cn: 'zh-CN',
  tw: 'zh-TW',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  nl: 'nl-NL',
  pt: 'pt',
});

const LOCALES_SUPPORT = Object.freeze({
  en: 'en-us',
  cn: 'zh-cn',
  tw: 'zh-tw',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  it: 'it',
  es: 'es',
  de: 'de',
  fr: 'fr',
});

const LOCALES_RECAPTCHA = Object.freeze({
  en: 'en',
  cn: 'zh-CN',
  tw: 'zh-TW',
  kr: 'ko',
  jp: 'ja',
  ru: 'ru',
  es: 'es',
  fr: 'fr',
  de: 'de',
  vn: 'vi',
  tr: 'tr',
  nl: 'nl',
  pt: 'pt',
  it: 'it',
  pl: 'pl',
});

const LOCALES_COMMON_UI = Object.freeze({
  en: 'en_US',
  cn: 'zh_CN',
  tw: 'zh_TW',
});

const LOCALES_ZENDESK_CHAT = Object.freeze({
  en: 'en-us',
  cn: 'zh-cn',
  tw: 'zh-tw',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  it: 'it',
  es: 'es',
  de: 'de',
  fr: 'fr',
});

export const getLocales = () => locales;

export const getHtmlLang = (locale = 'en') => LOCALES_HTML[locale] || 'en';

export const getTradingViewLocale = (locale = 'en') => LOCALES_TRADINGVIEW[locale] || 'en';

export const getCalendarLocale = (locale = 'en') => LOCALES_CALENDAR[locale] || 'en';

export const getSupportLocale = (locale = 'en') => LOCALES_SUPPORT[locale] || 'en';

export const getBlogLocales = (langes = LOCALES_BLOG) => langes.reduce((pre, cur) => {
  pre[cur] = LOCALES[cur];
  return pre;
}, {});

export const getLocalCacheKey = (locale = 'en') => locale;

export const getRecaptchaLocales = (locale = 'en') => LOCALES_RECAPTCHA[locale] || 'en';
export const getCommonUiLocales = (locale = 'en') => LOCALES_COMMON_UI[locale] || 'en';

export const getZendeskChatLocals = (locale = 'en') => LOCALES_ZENDESK_CHAT[locale] || 'en';
